import {useState} from "react";
import {Artist, convertArtistToType} from "../../../utils/artist.utils";
import {useValidateCodeMutation} from "../logic/queries/code.queries";

export const useCode = (artist: Artist) => {
  const [code, setCode] = useState<string>("");
  const [error, setError] = useState<string>("");

  const validateCodeMutation = useValidateCodeMutation();

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
    if (error) {
      setError("");
    }
  };

  const handleDelete = () => {
    setCode("");
    if (error) {
      setError("");
    }
  };

  const handleSubmit = async () => {
    try {
      if (!code.trim()) {
        setError(ERROR_MESSAGE.INVALID);
        return;
      }
      setError("");

      const type = convertArtistToType(artist);

      const response = await validateCodeMutation.mutateAsync({
        data: {
          type,
          code,
        },
      });

      console.log(response);

      return response;
    } catch (error) {
      const errorMessage = (error as Error).message;
      if (errorMessage === "This is an invalid code. Please try again.") {
        setError(ERROR_MESSAGE.INVALID);
        return;
      }
      if (errorMessage === "This code is expired") {
        setError(ERROR_MESSAGE.EXPIRED);
        return;
      }
      setError(ERROR_MESSAGE.UNKNOWN);
    }
  };

  const ERROR_MESSAGE = {
    INVALID: "invalid",
    EXPIRED: "expired",
    UNKNOWN: "unknown",
  } as const;

  return {
    code,
    error,
    ERROR_MESSAGE,
    handleCodeChange,
    handleDelete,
    handleSubmit,
  };
};
